import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, Grid, Typography, Popover, IconButton, MenuItem, Select } from "@material-ui/core";
import clsx from "clsx";
import { FormattedMessage, useIntl } from "react-intl";
import svgIdioma from "../static/Íconos/idioma.svg";
import svgphone from "../static/Íconos/phone-call.svg";
import svgMoneda from "../static/Íconos/moneda.svg";
import svgMenu from "../static/Íconos/Menu.svg";
import svgLogotipo from "../static/Identificador/Logo hotel.svg";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import DrawerComponent from "../components/Drawer";
import DrawerComponentLogin from "../views/Auth/Login";
import DrawerComponentRegister from "../views/Auth/Register";
import DrawerComponentNotification from "../views/Auth/Notificaciones";
import { useHistory } from "react-router-dom";
import { SERVER_URL } from "../config/backend";
import "./css/headerBar.css";
import { Notificaciones } from "../request/request_home";

const useStyles = makeStyles((theme) => ({
    imageIconHeader: {
        width: "7%",
    },
    fontHeaderLang: {
        fontFamily: "Verdana",
        fontSize: 14,
    },
    selectLang: {
        color: "#FFFFFF",
        "& .MuiSvgIcon-root": {
            color: "#FFFFFF",
        },
        "& .MuiSelect-select": {
            paddingRight: "0px !important",
        },
    },
    lineBar: {
        marginLeft: 5,
        marginTop: 5,
        marginRight: 5,
    },
    phoneBar: {
        marginLeft: 5,
        marginTop: 5,
        //marginRight: 10,
        fontFamily: "Verdana",
        fontSize: 16,
        whiteSpace: "nowrap",
    },
    inputLabel: {
        color: "#DFDFDF",
    },
    inputDate: {
        height: 100,
        width: 100,
    },
    punteroNav: {
        "&:hover": {
            cursor: "pointer",
        },
    },
}));

export default function HeaderBar(props) {
    const locale = useSelector((store) => store.user.lang);
    const money = useSelector((store) => store.user.money);
    const selector = useSelector((store) => store);
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useStyles();
    const intl = useIntl();

    //-------------------------------------------------------------------------------
    //----------------------------ESTADOS--------------------------------------------
    //-------------------------------------------------------------------------------
    const [page] = useState(props.page);
    const [namePage] = useState(props.namePage);
    const [ancho, setAncho] = useState(window.screen.width);
    const [openLang, setOpenLang] = useState(false);
    const [openMoney, setOpenMoney] = useState(false);
    const [rootPath] = useState(props.rootPath);
    const [childPath] = useState(props.childPath);
    const [anchorElTelefono, setAnchorElTelefono] = useState(null);
    const [globalNotificaciones, setGlobalNotificaciones] = useState([]);

    let rutaNavegacion = "";
    let lang = locale && locale !== "undefined" ? locale : "es";
    let moneyS = money && money !== "undefined" ? money : "cup";
    let style =
        page !== "home"
            ? {
                  backgroundColor: "#182C20",
                  opacity: "85%",
                  height: 270,
                  zIndex: 100
              }
            : { height: 100 };

    //-------------------------------------------------------------------------------
    //----------------------------FUNCIONES------------------------------------------
    //-------------------------------------------------------------------------------

    const handleClickTelefono = (event) => {
        setAnchorElTelefono(event.currentTarget);
    };

    const handleCloseTelefono = () => {
        setAnchorElTelefono(null);
    };

    const handleClickRootPath = () => {
        history.push(rootPath["path"]);
    };

    const onClickInicio = () => {
        history.push("/");
    };

    const handleChangeLang = (value) => {
        dispatch({ type: "LANG_OPERATION", lang: value });
        window.location.reload();
    };

    const handleChangeMoney = (value) => {
        var getExchangeRates = `query Exchange_Rates {
            exchangeRates {
              rate
              coin
            }
          }
          `;

        fetch(`${SERVER_URL}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Clientid: "3iwUHcPNqqHz6AIvzhlpgHdfAfOTJVZth84BX8bh",
                Clientsecret: "ivvDiNohSNdPmyAHv2IR7yHBLp3taXpvQEuwU4CrrMULAc3dnwYVX0Ughe8Dqk1rptnBWojPbVhf25duC0NqWniH5MOOS1ryQ9LgoNeiXgWCMU4cLQAZagOuAteFrgza",
            },
            body: JSON.stringify({
                operationName: "Exchange_Rates",
                query: getExchangeRates,
            }),
        })
            .then((r) => r.json())
            .then((data) => {
                if (data.data.exchangeRates.length > 0) {
                    dispatch({ type: "MONEY_OPERATION", money: value });
                    dispatch({ type: "LOAD_EXCHANGE_RATE", data: data.data.exchangeRates });
                }
            });
    };

    const handleClickMenu = () => {
        dispatch({ type: "DRAWER_OPERATION", status: true });
    };

    const handleClickLogo = () => {
        history.push("/");
    };

    const handleOpenLang = () => {
        setOpenLang(true);
    };

    const handleCloseLang = () => {
        setOpenLang(false);
    };

    const handleOpenMoney = () => {
        setOpenMoney(true);
    };

    const handleCloseMoney = () => {
        setOpenMoney(false);
    };

    const getNotificaciones = () => {
        if (selector.user.accessToken && selector.user.accessToken !== "") {
            Notificaciones(lang, selector.user.accessToken).then((item) => {
                setGlobalNotificaciones(item);
            });
        }
    };

    //-------------------------------------------------------------------------------
    //--------------------------------VISTA------------------------------------------
    //-------------------------------------------------------------------------------
    if (props.rootPath["name"] !== "") {
        rutaNavegacion = (
            <div>
                <label className={classes.punteroNav} style={{ color: "#DFDFDF", fontSize: "14px", fontFamily: "Verdana" }} onClick={onClickInicio}>
                    {rootPath["inicio"] === undefined ? "" : intl.formatMessage({ id: rootPath["inicio"] }).toString()}
                </label>

                <label className={childPath !== "" ? classes.punteroNav : ""} style={{ color: childPath !== "" ? "#DFDFDF" : "#A68A30", fontSize: "14px", fontFamily: "Verdana" }} onClick={handleClickRootPath}>
                    {rootPath["name"] === undefined ? "" : intl.formatMessage({ id: rootPath["name"] }).toString()} {childPath !== "" ? " / " : ""}
                </label>
                {childPath["name"] !== "" ? <label style={{ color: "#A68A30", fontSize: "14px", fontFamily: "Verdana" }}>{childPath["name"] === undefined ? "" : intl.formatMessage({ id: childPath["name"] }).toString()}</label> : ""}
            </div>
        );
    }

    useEffect(() => {
        getNotificaciones();
        window.addEventListener("resize", function () {
            setAncho(window.screen.width);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            <Grid container spacing={0} style={style}>
                <Grid item container xs={4} direction={ancho > 800 ? "row" : "column"} alignItems="center" justify={ancho > 800 ? "flex-start" : "center"} className={clsx(classes.gridItem)} style={{ color: "#FFFFFF", paddingLeft: ancho > 800 ? "3rem" : 10 }}>
                    {ancho > 800 && <img alt="Idioma" src={svgIdioma} style={{ marginRight: 5 }} />}
                    <Select
                        labelId="select-lang"
                        id="select-lang"
                        value={lang}
                        open={openLang}
                        onOpen={handleOpenLang}
                        onClose={handleCloseLang}
                        onChange={(e) => handleChangeLang(e.target.value)}
                        className={classes.selectLang}
                        IconComponent={() => (
                            <IconButton onClick={handleOpenLang} style={{ padding: 0 }}>
                                <KeyboardArrowDown />
                            </IconButton>
                        )}
                        disableUnderline
                    >
                        <MenuItem value={"es"}>
                            <Typography variant="inherit" className={classes.fontHeaderLang}>
                                ESP
                            </Typography>
                        </MenuItem>
                        <MenuItem value={"en"}>
                            <Typography variant="inherit" className={classes.fontHeaderLang}>
                                ENG
                            </Typography>
                        </MenuItem>
                    </Select>
                    {ancho > 800 && <div className={classes.lineBar}>|</div>}
                    {ancho > 800 && <img alt="Moneda" src={svgMoneda} style={{ marginRight: 5 }} />}
                    <Select
                        labelId="select-Money"
                        id="select-Money"
                        value={moneyS}
                        open={openMoney}
                        onOpen={handleOpenMoney}
                        onClose={handleCloseMoney}
                        onChange={(e) => handleChangeMoney(e.target.value)}
                        className={classes.selectLang}
                        IconComponent={() => (
                            <IconButton onClick={handleOpenMoney} style={{ padding: 0 }}>
                                <KeyboardArrowDown />
                            </IconButton>
                        )}
                        disableUnderline
                    >
                        <MenuItem value={"cup"}>
                            <Typography variant="inherit" className={classes.fontHeaderLang}>
                                CUP
                            </Typography>
                        </MenuItem>
                        <MenuItem value={"usd"}>
                            <Typography variant="inherit" className={classes.fontHeaderLang}>
                                USD
                            </Typography>
                        </MenuItem>
                        <MenuItem value={"eur"}>
                            <Typography variant="inherit" className={classes.fontHeaderLang}>
                                EUR
                            </Typography>
                        </MenuItem>
                    </Select>
                    {ancho > 800 ? (
                        <>
                            <div className={classes.lineBar}>|</div>
                            <img alt="Phone" src={svgphone} />
                            <div className={classes.phoneBar} style={{ fontSize: "16px" }}>
                                (+53)7 836 3564
                            </div>
                        </>
                    ) : (
                        <>
                            <img alt="Phone" src={svgphone} onClick={handleClickTelefono} style={{ marginTop: 5 }} />
                            <Popover
                                open={Boolean(anchorElTelefono)}
                                anchorEl={anchorElTelefono}
                                onClose={handleCloseTelefono}
                                anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                }}
                                transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                }}
                            >
                                <div style={{ background: "#182C20", padding: 10, fontSize: "16px", fontFamily: "Verdana", color: "#A68A30" }}>(+53)7 836 3564</div>
                            </Popover>
                        </>
                    )}
                </Grid>
                <Grid item container xs={4} alignItems="center" direction="column" style={{ marginTop: ancho < 576 ? 10 : 20 }} className={clsx(classes.gridItem)}>
                    <IconButton onClick={handleClickLogo}>
                        <img alt="LogoHotel" src={svgLogotipo} style={{ width: ancho < 400 ? 100 : 125, height: 'auto' }} />
                    </IconButton>
                </Grid>
                <Grid item xs={4} container direction="row" alignItems="center" justify="flex-end" className={clsx(classes.gridItem)}>
                    <IconButton aria-label="idioma" aria-controls="customized-menu" aria-haspopup="true" variant="contained" color="inherit" onClick={handleClickMenu} style={{ marginRight: ancho > 800 ? 50 : 10 }}>
                        <img alt="Menu" src={svgMenu} />
                    </IconButton>
                </Grid>
                {/* ruta de navegacion */}
                {page !== "home" ? (
                    <Grid container>
                        <Grid item xs={12} sm={12} md={3}>
                            <div id="ruta-navegacion">{rutaNavegacion}</div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} style={{ textAlign: "center" }}>
                            <Typography style={{ color: "#DFDFDF" }}>
                                <FormattedMessage id={page} />
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3}></Grid>
                        <Grid item xs={12} sm={12} md={3}></Grid>
                        <Grid item xs={12} sm={12} md={6} style={{ textAlign: "center" }}>
                            <Typography
                                style={{
                                    color: "#A68A30",
                                    fontSize: ancho < 576 ? "18pt" : "30pt",
                                    fontFamily: "georgia bold",
                                }}
                            >
                                {namePage}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} style={{ textAlign: "center" }}>
                            {/* {namePage === "PROMOCIONES" ? form : ""} */}
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} style={{ marginTop: "1rem" }}></Grid>
                    </Grid>
                ) : (
                    ""
                )}
            </Grid>
            <DrawerComponent globalNotificaciones={globalNotificaciones} setGlobalNotificaciones={setGlobalNotificaciones} />
            <DrawerComponentLogin setGlobalNotificaciones={setGlobalNotificaciones} />
            <DrawerComponentRegister />
            <DrawerComponentNotification globalNotificaciones={globalNotificaciones} setGlobalNotificaciones={setGlobalNotificaciones} />
        </div>
    );
}
